import { RecursoCapacitadora } from './../../../entity/recurso-capacitadora.model';
import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Anexo } from './../../../entity/anexo.model';
import { Recurso } from './../../../entity/Recurso.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { TelefoneTipo, EnderecoTipo } from "../../../entity/enumeraveis";
import { BaseStepComponent } from 'app/base';

@Component({
    selector: 'gerenciamento-capacitadora-etapa2',
    templateUrl: './gerenciamento-capacitadora-etapa2.component.html',
})
export class CrudGerenciamentoCapacitadoraEtapa2Component extends BaseStepComponent {
    @Input() classificacaoOptions: SelectItem[] = [];
    @Input() ufOptions: any[] = [];
    @Input() codigo: string;
    @Input() dataCadastro: Date;
    @Input() dataEnvio: Date;
    @Input() listaTipoLogradouro: SelectItem[];
    @Input() listaCidade: SelectItem[];
    @Input() controladorFilial: boolean;
    telefoneTipo = TelefoneTipo;
    enderecoTipo = EnderecoTipo;
    @Input() listaResponsaveis: any[] = [];
    @Input() listaEndereco: any[] = [];
    @Input() listaEmail: any[] = [];
    @Input() listaTelefone: any[] = [];
    @Input() listaResumo: any[] = [];
    @Input() listaRelatores: any[];
    @Input() uploadedFiles: any[];
    @Input() storagedListFiles: any[];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    @Output() controladorFilialChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    @Input() justificativa: string;
    @Input() listaAnexoRecurso: Anexo[] = [];
    @Input() recurso: RecursoFiltro;

    @Input() uploadedFilesJustificativa: any[] = [];
    @Output() uploadedFilesJusChange = new EventEmitter<any>();
    uploadedFilesJusTemp: any[] = [];
    @Input() id: number;
    @Input() cnpj: string;
    recurso_capacitadora: RecursoCapacitadora[] = [];

    init() {
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }

        this.uploadedFilesChange.emit(this.uploadedFiles);
        this.uploadedFilesJusChange.emit(this.uploadedFilesJustificativa);
        this.controladorFilialChange.emit(this.controladorFilial);
        if (this.id !== undefined) {
            this.service.Obter('capacitadora/recursoList', this.id).subscribe(item => {
                this.recurso_capacitadora = item;
            });
            this.recurso.IdModel = this.id;
        }
    }

    selecionaArquivo(event) {

        for (const file of event.files) {
            if (file.name.match(/.pdf/) || file.name.match(/.jpg/) || file.name.match(/.png/)) {
                this.IncluirArquivo(file, this.uploadedFilesJustificativa, this.uploadedFilesJusChange)
            }
        }

        if (this.uploadedFilesJustificativa.length) {
            this.uploadedFilesJusTemp = this.uploadedFilesJustificativa;
        }
    }

    removeElementList(value: any) {
        this.uploadedFilesJustificativa.forEach((item, index) => {
            if (item.nome_arquivo === value.file.name && item.id < 1) {
                super.removeFromList(this.uploadedFilesJustificativa, this.uploadedFilesJusChange, index, 'anexos');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-capacitadora/crud/etapas/gerenciamento-capacitadora-etapa2.component.ts